import * as React from 'react';
import s from '../../RequestCall.scss';
import { FormInputProps } from './FormTypes';
import { Translation } from 'react-i18next';
import { FormContext } from './FormContext';

import { InputArea, Text, Cell } from '@wix/design-system';

export const FormInputArea: React.FC<FormInputProps> = ({ label, name }) => {
  const { values: formValues, handleChange } = React.useContext(FormContext);
  return (
    <Translation>
      {(t) => (
        <>
          <Cell span={12}>
            <div className={s.inputLabel}>
              <Text weight='normal' size='medium'>
                {t(label)}
              </Text>
            </div>
            <InputArea
              size="medium"
              name={name}
              resizable
              placeholder={t(`${label}.placeholder`)}
              value={formValues[name]}
              onChange={handleChange}
            />
          </Cell>
        </>
      )}
    </Translation>
  );
};
